const actions = {
    FETCH_EXAM_CALENDAR_LIST: 'FETCH_EXAM_CALENDAR_LIST',
    FETCH_EXAM_CALENDAR: 'FETCH_EXAM_CALENDAR',
    RESET_EXAM_CALENDAR_FORM: 'RESET_EXAM_CALENDAR_FORM',

    // Action for fetching the paginated list / calendar grid results
    fetchExamCalendarListAction: (data) => {
        return {
            type: actions.FETCH_EXAM_CALENDAR_LIST,
            data: data
        };
    },

    // Action for resetting the form (useful when closing a modal or clearing state)
    resetExamCalendarFormAction: () => {
        return {
            type: actions.RESET_EXAM_CALENDAR_FORM,
            data: null
        };
    },

    // Action for fetching single Exam Calendar entry details (useful for editing)
    fetchExamCalendarAction: (data) => {
        return {
            type: actions.FETCH_EXAM_CALENDAR,
            data: data
        };
    },
};

export default actions;